import { render } from "./DonationCard.vue?vue&type=template&id=7da7b83c"
import script from "./DonationCard.vue?vue&type=script&lang=js"
export * from "./DonationCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__